export default __webpack_public_path__ + "static/media/RB_Rockwool.6e90d1ce.jpg";